import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { formatDate } from 'products/nomad_insurance/utils';
import { getMobileAppLink } from 'helpers';
import { fetchContracts } from 'products/nomad_insurance/state/contract';
import Notice from 'products/nomad_insurance/components/Notice';
import BirdThanks from 'products/nomad_insurance/assets/img/birds/bird_thanks.png';
import {
  Container,
  BirdImg,
  Texts,
  Infos,
  Paragraph,
  MobileParagraph,
  DashboardButton,
  AppButton,
  FeedbackContent,
  FeedbackText,
  FeedbackButton
} from './styled';

const ThankYou = () => {
  const dispatch = useDispatch();
  // @ts-ignore state is not typed
  const { data: planholder } = useSelector((state) => state.app.profile);
  const { policyID } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.purchaseInsurance.worldTripsPayment
  );
  // @ts-ignore state is not typed
  const { allActiveContracts } = useSelector((state) => state.nomadInsurance.contract);

  const currentContract = useMemo(() => {
    if (!allActiveContracts) return null;
    const contractsSortedByStartDate = [...allActiveContracts].sort(
      (a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
    );
    return contractsSortedByStartDate.length > 0 && contractsSortedByStartDate[0];
  }, [allActiveContracts]);

  useEffect(() => {
    if (!currentContract) {
      dispatch(fetchContracts());
    }
  }, [dispatch, currentContract]);

  const getEndDateText = () => {
    if (currentContract?.renewalDate) {
      return `Auto-extend every 4 weeks until ${formatDate(
        currentContract.renewalDate,
        'MMMM d, yyyy'
      )}`;
    }

    return formatDate(currentContract?.endDate, 'MMMM d, yyyy');
  };

  const handleDownloadClick = () => {
    window.open(getMobileAppLink(), '_blank', 'noopener');
  };

  return (
    <Container>
      <BirdImg src={BirdThanks} alt="Bird saying thanks" />
      <Texts>
        <h1>You're all set, {planholder.firstName}!</h1>
        <Infos>
          {policyID && (
            <div>
              Policy number: <b>{policyID}</b>
            </div>
          )}
          {currentContract?.startDate && (
            <div>
              Start date: <b>{formatDate(currentContract.startDate, 'MMMM d, yyyy')}</b>
            </div>
          )}
          {(currentContract?.endDate || currentContract?.renewalDate) && (
            <div>
              End date: <b>{getEndDateText()}</b>
            </div>
          )}
        </Infos>

        <MobileParagraph>
          You'll receive a confirmation email shortly with your insurance card and policy
          information. For now, explore your dashboard or download the app where you can
          manage your policy and make claims.
        </MobileParagraph>
        <Paragraph>
          You'll receive a confirmation email shortly with your insurance card and policy
          information.
        </Paragraph>
        <Paragraph>
          For now, explore your dashboard where you can:
          <ul>
            <li>Check your coverage</li>
            <li>Make a claim</li>
            <li>Download visa letter</li>
            <li>Update personal information</li>
            <li>Access the referral program to give $20, get $20</li>
          </ul>
        </Paragraph>

        <DashboardButton
          color="pickledBluewood"
          onClick={() => {
            window.location.href = '/dashboard/nomad-insurance';
          }}
        >
          Explore my dashboard
        </DashboardButton>

        <AppButton
          color="pickledBluewood"
          variant="transparentOutline"
          onClick={handleDownloadClick}
        >
          Download mobile app
        </AppButton>

        <Notice variant="info">
          <FeedbackContent>
            <FeedbackText>
              <strong>Have a minute to spare?</strong>
              We would love your feedback on your purchasing experience with us.
            </FeedbackText>
            <FeedbackButton
              variant="outline"
              thickness="thin"
              onClick={() =>
                window.open(
                  'https://safetywinginsurance.typeform.com/signup-nps',
                  '_blank',
                  'noopener'
                )
              }
            >
              Give feedback
            </FeedbackButton>
          </FeedbackContent>
        </Notice>
      </Texts>
    </Container>
  );
};

export default ThankYou;
